module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_add-to-unscopables.js
// module id = pwcn
// module chunks = 0